import React, { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import { Button } from '@mui/material';
import ResourcePageValidator from '../validators/resourcesPageValidator';
import { permissionOptions } from '../constants/resourcePermissionOptions';
import ResourceInputFields from './ResourceInputFields';
import ResourcesMapper from '../mappers/ResourcesMapper';

/**
 * @typedef {object} AddResourceFormProps
 * @property {(newResource: Object) => void} handleAddNewResource
 */

/**
 * @param {AddResourceFormProps} props
 */
const AddResourceForm = props => {
  const { handleAddNewResource } = props;

  const form = useForm({
    resolver: joiResolver(ResourcePageValidator.addSchema),
    defaultValues: {
      category: '',
      title: '',
      description: '',
      link: '',
      permissions: permissionOptions
    }
  });

  const { handleSubmit, control, reset } = form;

  const onSubmit = newResource => {
    handleAddNewResource(ResourcesMapper.newResourceToResourceData(newResource));
    reset();
  };

  const fieldNameProvider = useCallback(fieldName => {
    return fieldName;
  }, []);

  return (
    <form
      className='add-resource-form'
      data-testid='add-resource-form'
      onSubmit={handleSubmit(onSubmit)}>
      <ResourceInputFields
        control={control}
        displayTitles={true}
        fieldNameProvider={fieldNameProvider}
      />
      <div className='approve-button'>
        <Button className='primary-button sm' type='submit'>
          Add
        </Button>
      </div>
    </form>
  );
};

export default AddResourceForm;
